import { LayoutComponent }                from '../layout/layout.component';

import { LoginComponent }                 from './user/login/login.component';
import { AuthGuardService }               from '../services/auth-guard/auth-guard.service';
import { EncuestaResponderComponent }     from './encuesta/encuesta-responder/encuesta-responder.component';
import { SubscribirseComponent } from './encuesta/subscribirse/subscribirse.component';

export const routes = [{
  path: '',
  component: LayoutComponent,
  children: [
    {
      path: '',
      redirectTo: 'dashboard',
      pathMatch: 'full',
      canActivate: [AuthGuardService]
    }, {
      path: 'dashboard',
      canActivate: [AuthGuardService],
      loadChildren: './dashboard/dashboard.module#DashboardModule'
    },
    {
      path: 'administracion',
      canActivate: [AuthGuardService],
      loadChildren: './administracion/administracion.module#AdministracionModule'
    },
    {
      path: 'usuarios',
      canActivate: [AuthGuardService],
      loadChildren: './usuarios/usuarios.module#UsuariosModule'
    }
  ]},
  { path: 'login', component: LoginComponent },
  { path: 'cuestionario/:identificador', component: EncuestaResponderComponent },
  { path: 'suscribirse/:identificador', component: SubscribirseComponent },
  // Not found
  { path: '**', redirectTo: 'dashboard' }
];



// WEBPACK FOOTER //
// ./src/app/routes/routes.ts